module.exports = __webpack_public_path__ + "static/media/oevt2-logo.0f303238.png";